/**
 * Soéva Bundle Manager
 * Ajoute automatiquement l'huile associée quand un pack est ajouté au panier
 */

(function() {
  const CONFIG = window.SoevaBundleConfig;
  if (!CONFIG) return;

  const _fetch = window.fetch;
  window.fetch = async function(url, options = {}) {
    const response = await _fetch.apply(this, arguments);

    if (
      typeof url === 'string' &&
      url.includes('/cart/add') &&
      options.method?.toUpperCase() === 'POST'
    ) {
      try {
        const body = JSON.parse(options.body || '{}');
        const variantId = body.id || body.items?.[0]?.id;
        const bundleInfo = CONFIG.bundleMap[variantId];

        if (bundleInfo) {
          await addOilToCart(bundleInfo, variantId);
        }
      } catch(e) {
        console.error('[Soéva Bundle] Erreur ajout huile:', e);
      }
    }

    return response;
  };

  async function addOilToCart(bundleInfo, packVariantId) {
    await _fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: bundleInfo.oilVariantId,
        quantity: 1,
        properties: {
          [CONFIG.bundleProperty]: packVariantId,
          '_pack_label': 'Inclus dans votre pack'
        }
      })
    });
  }

  console.log('[Soéva Bundle] ✅ Chargé et actif');
})();
